module.exports = __webpack_public_path__ + "img/icon-ranking.0e98e267.svg";